import { DeleteOutlined } from '@ant-design/icons';
import { Input, Select } from 'antd';
import PropTypes from 'prop-types';
import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { PHONE_TYPES } from '@/components/PhoneNumberField/PhoneInput/constants';
import { useResponsive } from '@/contexts/ResponsiveContext';

import style from './index.less';

const { Option } = Select;

const PhoneInput = ({ type, phone, onChange, canRemove, onRemove, haveType, ...props }) => {
  const { t } = useTranslation('common');
  const { isMobile } = useResponsive();

  const onChangeType = useCallback((type) => {
    onChange && onChange({ type, phone });
  }, [onChange, phone]);

  const onChangeValue = useCallback((e) => {
    onChange?.({ type, phone: e.target.value });
  }, [onChange, type]);

  return (
    <Input.Group compact className="mb-3 flex items-center">
      {haveType && <Select
        {...props}
        value={type}
        defaultValue={PHONE_TYPES.WORK}
        style={{ minWidth: isMobile ? '35%' : '25%' }}
        onChange={onChangeType}
      >
        {Object.keys(PHONE_TYPES).map((type) => {
          return <Option key={type} value={PHONE_TYPES[type]}>
            {t(`phone_types.${type}`)}
          </Option>;
        })}
      </Select>}
      <Input
        {...props}
        className={style.inputClass}
        onChange={onChangeValue}
        value={phone}
        defaultValue={''}
        style={{ width: haveType ? (isMobile ? '65%' : '80%') : '100%' }}
      />
      {canRemove && <div
        onClick={onRemove}
        className="text-center cursor-pointer pl-4 flex items-center justify-center hover:text-primary"
        style={{ height: '40px', minWidth: '30px' }}>
        <DeleteOutlined/>
      </div>}
    </Input.Group>
  );
};

export default memo(PhoneInput);

PhoneInput.propTypes = {
  onChangeType: PropTypes.func,
  canRemove: PropTypes.bool,
  haveType: PropTypes.bool,
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  type: PropTypes.string,
  phone: PropTypes.string,
};

PhoneInput.defaultProps = {
  value: [],
  haveType: true
};
